export const resolveShowCost = (reportProfile) => {
    const raw = reportProfile?.showCost ?? reportProfile?.show_cost;

    if (typeof raw === 'boolean') return raw;
    if (typeof raw === 'number') return raw === 1;
    if (typeof raw === 'string') {
        const normalized = raw.trim().toLowerCase();
        return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on';
    }

    return false;
};

export const normalizeReportProfileVisibility = (reportProfile) => {
    if (!reportProfile || typeof reportProfile !== 'object') return reportProfile;

    return {
        ...reportProfile,
        showCost: resolveShowCost(reportProfile)
    };
};
